import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import Store from "../store";

@Module({
  dynamic: true,
  name: "languageModule",
  namespaced: true,
  store: Store
})
export default class LanguageModule extends VuexModule {
  private languageState = "fr_CH";

  get language() {
    return this.languageState;
  }

  @Action({ commit: "set" })
  public async setAsync(language: string) {
    // do something async here ...
    // this is just an example how to do async stuff.
    return language;
  }

  @Mutation
  public set(language: string) {
    this.languageState = language;
  }
}
